@if (project) {
  <div class="flex-column h-100">
    <div class="configuration-wizard-header flex-column">
      <h5 class="odx-title-5" i18n="@@plasticSignConfiguration.selectPlasticSign.header">Kunststoffschild auswählen</h5>
      <app-filter-product (searchEvent)="search($event)"></app-filter-product>
    </div>

    <odx-content-box class="flex-column flex-scroll" odxLayout="flex">
      @if (filteredPlasticSigns$ | async; as plasticSigns) {
        @if (plasticSigns.length > 0) {
          <form [formGroup]="plasticSignForm" class="h-100 overflow-hidden">
            <odx-radio-group formControlName="selectedPlasticSign" required="true" class="overflow-hidden h-100">
              <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100">
                @for (plasticSign of plasticSigns; track plasticSign) {
                  <app-product-card
                    class="overflow-hidden"
                    [product]="plasticSign"
                    [showCosts]="project.showCostFlag"
                    [isSelected]="plasticSignForm.value.selectedPlasticSign?.id === plasticSign.id"
                    (click)="updateSelectedPlasticSign(plasticSign)"
                    (select$)="updateSelectedPlasticSign(plasticSign)"
                    selectionMode="single"
                  >
                    @if (plasticSign.id) {
                      <div class="feature">
                        <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
                        <p class="odx-text--small">{{ plasticSign.id }}</p>
                      </div>
                    }
                  </app-product-card>
                }
              </div>
            </odx-radio-group>
          </form>
        } @else {
          <app-refresh-products-hint
            dataType="Kunststoffschilder"
            i18n-dataType="@@global.plasticSigns"
          ></app-refresh-products-hint>
        }
      }
    </odx-content-box>
  </div>
}
